import * as Dialog from "@radix-ui/react-dialog";
import { Button } from "../../Button";
import { Close } from "@/icons";
import "./ConsentModalHeader.scss";

type ConsentModalHeaderProps = {
  closeButton?: string;
  onCloseClick?: () => void;
  children?: React.ReactNode;
};

export const ConsentModalHeader = ({
  closeButton = "Chiudi",
  onCloseClick,
  children,
}: ConsentModalHeaderProps) => {
  return (
    <header className="ui-consent-modal-header shadow bg-white">
      <Dialog.Title className="fs-6 md-fs-custom text-slate-20 fw-bold">
        {children}
      </Dialog.Title>
      <Dialog.Close asChild className="ui-consent-modal-header-close">
        <Button
          size="4"
          textColor="primary"
          bg="transparent"
          aria-label="Chiudi modale"
          onClick={onCloseClick}
        >
          {closeButton}
          <Close className="ml-x8" />
        </Button>
      </Dialog.Close>
    </header>
  );
};
